// /utils/emotionCache.js

import createCache from '@emotion/cache';
import { getCspNonce } from '../src/utils/getCspNonce';

export default function createEmotionCache() {
  const nonce = getCspNonce() || undefined;
  return createCache({ key: 'css', nonce });
}
